import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { z } from 'zod'
import { axiosInstance } from '../axios-instance'
import { notificationFilterShape, notificationShape } from './models'

const markRead = createCustomServiceCall({
  inputShape: z.string().uuid(),
  outputShape: notificationShape,
  cb: async ({ client, slashEndingBaseUri, input, utils: { fromApi } }) => {
    const response = await client.patch(`${slashEndingBaseUri}${input}/read/`)
    return fromApi(response.data)
  },
})

const markAllRead = createCustomServiceCall({
  outputShape: { updated: z.number() },
  cb: async ({ client, slashEndingBaseUri, utils: { fromApi } }) => {
    const response = await client.post(`${slashEndingBaseUri}mark-all-read/`)
    return fromApi(response.data)
  },
})

const unreadCount = createCustomServiceCall({
  outputShape: { count: z.number() },
  cb: async ({ client, slashEndingBaseUri, utils: { fromApi } }) => {
    const response = await client.get(`${slashEndingBaseUri}unread-count/`)
    return fromApi(response.data)
  },
})

export const notificationApi = createApi({
  client: axiosInstance,
  baseUri: '/notifications/',
  models: {
    entity: notificationShape,
    extraFilters: notificationFilterShape,
  },
  customCalls: {
    markRead,
    markAllRead,
    unreadCount,
  },
})
